/**
 * Product card second-image reveal.
 * Mouse: the second photo shows on hover (CSS). Touch: the first tap shows the
 * second photo, the next tap follows the product link. Keyboard keeps normal links.
 */
class CardImageSwapElement extends HTMLElement {
  #pointerType = '';
  #abort = null;

  connectedCallback() {
    if (!this.querySelector('[data-swap-image]')) return;
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.addEventListener(
      'pointerdown',
      (event) => {
        this.#pointerType = event.pointerType;
      },
      { signal }
    );

    this.addEventListener(
      'click',
      (event) => {
        const isTouch = this.#pointerType === 'touch' || this.#pointerType === 'pen';
        this.#pointerType = '';
        if (!isTouch || this.hasAttribute('swapped')) return;
        event.preventDefault();
        this.#resetOthers();
        this.setAttribute('swapped', '');
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#abort = null;
  }

  #resetOthers() {
    for (const card of document.querySelectorAll('s-card-image-swap[swapped]')) {
      if (card !== this) card.removeAttribute('swapped');
    }
  }
}

if (!customElements.get('s-card-image-swap')) {
  customElements.define('s-card-image-swap', CardImageSwapElement);
}
